import { Container, Box, Typography, Divider, Stack } from '@mui/material'

import ContentTabs, {
  ContentTabsProps,
} from '@src/components/content/ContentTabs'
import {
  Breadcrumbs,
  Breadcrumb,
  BreadcrumbMenu,
  BreadcrumbProps,
  BreadcrumbMenuProps,
} from '@src/components/shared/Breadcrumbs'
import MessageBar from '@src/components/shared/MessageBar'
import BottomBeaconSpacer from '@src/lib/BottomBeaconSpacer'

interface FilterContentLayoutWrapperProps {
  title: React.ReactNode
  description?: React.ReactNode
  left?: React.ReactNode
  slot?: {
    filter?: React.ReactNode
    breadCrumbs?: React.ReactNode
  }
  slotProps?: {
    tab?: ContentTabsProps
    breadCrumb?: BreadcrumbProps
    breadCrumbMenu?: BreadcrumbMenuProps
    messageBar?: {
      isDismissable: boolean
      link: string
      linkText: string
      text: string
      type: string
    }
  }
}

const FilterContentLayoutWrapper: React.FC<
  React.PropsWithChildren<
    React.PropsWithChildren<FilterContentLayoutWrapperProps>
  >
> = (props) => {
  return (
    <>
      {props.slotProps?.messageBar && (
        <MessageBar {...props.slotProps.messageBar} />
      )}
      <Box sx={{ paddingX: 3, paddingY: 4 }}>
        <Stack direction="row" spacing={2}>
          {props.left}

          <Box flexGrow="1">
            {props.slotProps?.breadCrumb ? (
              <Breadcrumbs>
                <Breadcrumb {...props.slotProps.breadCrumb}>
                  <Typography color="text.primary" variant="h5">
                    {props.title}
                  </Typography>
                </Breadcrumb>
                {props.slot?.breadCrumbs}
                {props.slotProps.breadCrumbMenu && (
                  <BreadcrumbMenu {...props.slotProps.breadCrumbMenu} />
                )}
              </Breadcrumbs>
            ) : (
              <Typography variant="h5">{props.title}</Typography>
            )}

            {props.description}
          </Box>
        </Stack>
      </Box>
      {props.slotProps?.tab && <ContentTabs {...props.slotProps.tab} />}
      <Divider />
      <Container maxWidth="lg">
        {/* Content Filters Portal Renders Here */}
        {props.slot?.filter ? (
          <Box sx={{ paddingTop: 2 }}>{props.slot.filter}</Box>
        ) : null}
        {props.children}
      </Container>
      <BottomBeaconSpacer />
    </>
  )
}

export default FilterContentLayoutWrapper
